import { Format } from './format.interface';
import { Card, Query } from '@deckplan.io/common';

export class Legacy extends Format {

    public addCardsQuery(): Query {
        return {
            dataField: {
                title: 'Legalities',
                field: 'legalities',
                dataType: 'string'
            },
            operation: 'includes',
            value: `"legacy":"legal"`
        };
    }

    public validate(): Card[] {
        return this.deck.cards.filter(c =>
            // All cards not legal in legacy are invalid
            c.legalities.legacy === 'not_legal'
        );
    }

}
